import type { MouseEvent as ReactMouseEvent } from "react";
import "./PingDefaultButton.scss";
import { Flex, Icon, IconName } from "@repo/ping-design";

type PingDefaultButtonProps = {
  label: string[];
  iconName: IconName;
  url: string;
  disabled?: boolean;
};

const PingDefaultButton = ({
  label,
  iconName,
  url,
  disabled = false,
}: PingDefaultButtonProps) => {
  const className = `PingDefaultButton${disabled ? " PingDefaultButton--disabled" : ""}`;

  const handleClick = (event: ReactMouseEvent<HTMLAnchorElement>) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  return (
    <a
      className={className}
      href={disabled ? undefined : url}
      target={disabled ? undefined : "_blank"}
      rel={disabled ? undefined : "noreferrer"}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : undefined}
      onClick={handleClick}
    >
      <Flex
        className="PingDefaultButton__Content"
        direction="row"
        gap="2"
        align="center"
        justify="center"
      >
        <Icon
          iconName={iconName}
          className="PingDefaultButton__Content__Icon"
        />
        <Flex direction="column" gap="0-5">
          {label.map((l) => (
            <p className="PingDefaultButton__Content__Label">{l}</p>
          ))}
        </Flex>
      </Flex>
    </a>
  );
};

export default PingDefaultButton;
